///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../common/collection-api.ts"/>

module Meevo.Components.Controls.SmartMover {
    import IReportEmployee = Meevo.Plugins.Reports.IReportEmployee;

    export class CSEEmployeesCollection extends ReportEmployeesCollection implements IApiCollection<IReportEmployee> {
        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }
    }
}
